import React from 'react';
import { useTranslations } from '../../../locales/useTranslations';

const PowerBIProjekte = () => {
    const { t } = useTranslations();
    return (
        <section className="case-studies-area pt-100 pb-70 powerbi-projekte">
            {/* Dekorative Hintergrund-Elemente */}
            <div className="powerbi-projekte__decoration powerbi-projekte__decoration--top-right"></div>
            <div className="powerbi-projekte__decoration powerbi-projekte__decoration--bottom-left"></div>

            <div className="container powerbi-projekte__container">
                <div className="section-title text-center">
                    <span className="powerbi-projekte__badge">
                        {t('powerBi_projekte_title')}
                    </span>
                    <h2 className="powerbi-projekte__title">
                        {t('powerBi_projekte_title2')}
                    </h2>
                </div>
            </div>

            <div className="container powerbi-projekte__container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="powerbi-projekte__card">
                            <p className="powerbi-projekte__description">
                                {t('powerBi_projekte_description')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PowerBIProjekte;
